import React, { useContext } from "react";
import {
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonButton,
} from "@ionic/react";
import { Icon, CircleArrowRightIcon } from "evergreen-ui";
import { Link } from "react-router-dom";
import { globalContext } from "../../global/Store";
import { GetEmptyUser } from "../../global/Generic";

const Header: React.FC = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const encompassLogo = require("../../assets/encompassIcon/Encompass.png");

  const logout = () => {
    dispatch({
      type: "SET_USER",
      payload: GetEmptyUser(),
    });
  };

  return (
    <IonHeader className="ion-no-border">
      <IonToolbar style={{ paddingTop: "10px" }}>
        <Link
          slot="start"
          to="/home"
          style={{ paddingTop: "-10px", paddingLeft: "50px" }}
        >
          <img
            src={"../assets/icon/jmLogoTransWhite.png"}
            style={{ height: "50px" }}
          ></img>
        </Link>
        <Link
          slot="end"
          to="/home"
          style={{ paddingTop: "-10px", paddingRight: "50px" }}
        >
          <img src={encompassLogo} style={{ height: "50px" }}></img>
        </Link>

        <Link
          slot="end"
          to="/login"
          style={{ width: "200px" }}
          onClick={logout}
        >
          <IonButtons
            style={{
              float: "right",
              color: "white",
              marginRight: "15px",
              display: "grid",
              width: "100%",
            }}
          >
            <div>
              <IonButton>
                <div
                  className="header-dark-text"
                  style={{
                    paddingRight: "10px",
                    marginTop: "0px",
                    textTransform: "capitalize",
                  }}
                >
                  Logout
                </div>
                <Icon
                  className="header-dark-text"
                  icon={CircleArrowRightIcon}
                  size={20}
                />
              </IonButton>
            </div>

            <div
              className="header-dark-text"
              style={{ display: "inline-flex" }}
            >
              {/* Logged in as:&nbsp;  {globalState.user.forename} {globalState.user.surname} */}
              {globalState.user.forename} {globalState.user.surname}
            </div>
          </IonButtons>
        </Link>
        <IonTitle></IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};

export default Header;
